// extracted by mini-css-extract-plugin
export default {"value":"Options_value__OZpf0","name":"Options_name__zq8FF","icon":"Options_icon__h3F4e"};